/* unplugin-vue-components disabled */import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, Teleport as _Teleport, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import { useSchemaOrg, defineWebPage, defineWebSite } from "@unhead/schema-org";
import Index from "@/components/header/index.vue";
import { useMeta } from "vue-meta";
export default {
  __name: 'index',
  setup(__props) {
    const {
      useActions
    } = createNamespacedHelpers("plans");
    const countries = createNamespacedHelpers("countries");
    const dashboard = createNamespacedHelpers("dashboard");
    const user = createNamespacedHelpers("user");
    const {
      resetAllSession
    } = useActions(["resetAllSession"]);
    const {
      resetIsComingFrom
    } = user.useActions(["resetIsComingFrom"]);
    const {
      fetchAllcountries
    } = countries.useActions(["fetchAllcountries"]);
    const {
      allCountries
    } = countries.useState(["allCountries"]);
    const {
      resetsetUserDashboard
    } = dashboard.useActions(["resetsetUserDashboard"]);
    if (toRaw(allCountries.value) == null) {
      fetchAllcountries();
    }
    // useMeta({
    //   title: 'G1G Travel & Visitors Insurance'
    // });

    //all need reset session for project

    /*resetAllSession();
    resetsetUserDashboard();
    resetIsComingFrom();*/

    // useSchemaOrg([
    //   defineWebSite({
    //     name: "My Awesome Website",
    //   }),
    //   defineWebPage(),
    // ]);

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("template", null, [(_openBlock(), _createBlock(_Teleport, {
        to: "head"
      }, [(_openBlock(), _createBlock(_resolveDynamicComponent('script'), {
        type: "application/ld+json"
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [_createTextVNode(" { \"@context\": \"http://schema.org/\", \"@type\": \"WebSite\", \"name\": \"Go One Global\", \"about\": \"G1G Travel & Visitors Insurance allows you to review and compare the best travel insurance options from top rated travel insurnace companies around the world. G1G protects all types of travelers against the physical and financial risks of traveleing. G1G's unique technology makes recommendations of plans based on your specific trip, ensuring you get the best price and coverage.\", \"audience\": \"travelers, visitors, visitors to usa, travel, air travel, tourists, immigrants, green card holders, shoppers, value shoppers, cruise, tours, international students, technology, technophiles, arts & entertainment, lifestyles, accommodations, bollywood, financial planners, insurance agents, travel agencies, travel agency, online travel agency, travel agents, hotels, accommodations, world nomads, travel nomads, nomads, expatriates, expats, au pairs, international travel, travel bloggers, backpackers, campers, extreme sports, adventurers, adventure travel, visa help, embassy, embassies, travel visa, business services\", \"locationCreated\": \"San Jose, California\", \"mainEntity\": \"G1G\", \"keywords\": \"travel insurance, travel insurance comparison, travel protection insurance, travel protection, travel insurance companies, travel insurance reviews, travel insurance usa, travelex, insuremytrip, trip insurance, flight insurance, international travel insurance, best travel insurance, visitors insurance, visitor insurance, visitors insurance for parents, visitors insurance reviews, visitors insurance for parents from india, visitor medical insurance, best visitor insurance usa, compare visitors insurance, insubuy, visitors coverage, visitorscoverage, student travel insurance, schengen visa, schengen visa requirements, schengen visa application, schengen visa insurance, visa for europe insurance, expatriate, expat health insurance, travel medical insurance, international health insurance, expat insurance, expatriate insurance, international medical insurance, emergency medical evacuation, terrorism travel insurance, group travel insurance, seven corners, hccmis, img global, travel safe\", \"url\": \"https://www.g1g.com/\", \"potentialAction\": { \"@type\": \"SearchAction\", \"target\": \"https://www.g1g.com/?s={search_term_string}\", \"query-input\": \"required name=search_term_string\" } } ")])),
        _: 1
      }))]))]), _createVNode(Index)], 64);
    };
  }
};